import styled from "styled-components";

// This Wrapper is temporary until we have
// a fullHeight prop on the Stack

export const CardWrapper = styled.div`
  height: 100%;
  display: flex;
`;
